import React from 'react';
import Money from '../../../../../../../Money';
import cn from 'classnames';
import { useTheme } from '../../../../../../../theme';
import { CheckinCardItem } from '@shared/CheckinCard';
export const PriceItem = ({ name, price, isMinus, delimiter, className }) => {
    const { PriceItem: css } = useTheme('Entities').Order.ExchangeRefundPriceDetails;
    const priceWithoutMinus = (price === null || price === void 0 ? void 0 : price.amount) ? Math.abs(price === null || price === void 0 ? void 0 : price.amount) : 0;
    const showSing = isMinus && priceWithoutMinus > 0;
    return (React.createElement(CheckinCardItem, { className: cn(css.root, className), delimiter: delimiter ? 'line' : undefined, delimiterGap: !!delimiter },
        React.createElement("div", { className: css.title }, name),
        React.createElement("div", null,
            !!showSing && React.createElement("span", null, "-"),
            React.createElement(Money, { money: Object.assign(Object.assign({}, price), { amount: priceWithoutMinus }) }))));
};
export default PriceItem;
